export default __webpack_public_path__ + "static/media/298.597efa58.png";